import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Reads `profiles.onboarding_completed` once per user and exposes a
 * `finish()` method that persists completion. Returns whether the
 * onboarding overlay should be shown.
 */
export function useOnboarding(userId: string | null | undefined) {
  const [show, setShow] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("profiles")
        .select("onboarding_completed")
        .eq("user_id", userId)
        .maybeSingle();
      if (cancelled) return;
      if (data && !data.onboarding_completed) setShow(true);
      setLoaded(true);
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  const finish = useCallback(async () => {
    setShow(false);
    if (!userId) return;
    await supabase.from("profiles").update({ onboarding_completed: true }).eq("user_id", userId);
  }, [userId]);

  return { show, setShow, loaded, finish };
}